import Map from './components/Map';

export default Map;
